import React, {useState} from 'react';
import {useHostName} from 'presentation/hooks';
import {HapvidaContactChannels} from './brands/HapvidaContactChannels';
import {ClinipamContactChannels} from './brands/ClinipamContactChannels';
import {NdiMinasContactChannels} from './brands/NdiMinasContactChannels';
import {CCGContactChannels} from './brands/CCGContactChannels';
import {NdiSaoPauloContactChannels} from './brands/NdiSaoPauloContactChannels';
import {NotredameContactChannels} from './brands/NotredameContactChannels';
import {ContactChannelsBrandProps} from './types';

export function ContactChannels() {
	const {isCCG, isClinipam, isGndiMinas, isHAP, isGndiSaoPaulo, isNotredameSaude} = useHostName();
	const [expandedState, setExpandedState] =
		useState<ContactChannelsBrandProps['expandedState']>(false);

	const handleAccordionToggle: ContactChannelsBrandProps['handleAccordionToggle'] =
		panel => (_event, isExpanded) => {
			setExpandedState(isExpanded ? panel : false);
		};

	const BrandContactChannels = [
		{matches: isHAP, Component: HapvidaContactChannels},
		{matches: isClinipam, Component: ClinipamContactChannels},
		{matches: isGndiMinas, Component: NdiMinasContactChannels},
		{matches: isCCG, Component: CCGContactChannels},
		{matches: isGndiSaoPaulo, Component: NdiSaoPauloContactChannels},
		{matches: isNotredameSaude, Component: NotredameContactChannels},
	].find(brand => brand.matches)?.Component;

	if (!BrandContactChannels) return null;

	return (
		<BrandContactChannels
			expandedState={expandedState}
			handleAccordionToggle={handleAccordionToggle}
		/>
	);
}
